import { BASE_SCORE, SCORE, ScoreType } from '@shared/score-detail/components/score';

export function getLegendByScore(score: number): string {
  let scoreLegend = ScoreType.Nice;
  scoreLegend = score >= 9 ? ScoreType.Fantastic :
    score >= 8 ? ScoreType.Fabulous :
      score >= 7 ? ScoreType.Good : scoreLegend;
  return `${BASE_SCORE}${SCORE[scoreLegend]}`;
}
